import { card, colors, fonts, sizes } from '../../theme';

const styles = {
  card,
  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1.5,
    minHeight: sizes.cardHeader,
    px: 2.5,
    borderBottom: `1px solid ${colors.border}`,
    boxSizing: 'border-box',
  },
  title: {
    display: 'flex',
    alignItems: 'center',
    gap: 1,
    fontFamily: fonts.text,
    fontSize: 15,
    fontWeight: 700,
    color: colors.text,
  },
  body: {
    p: 2.5,
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
};

export default styles;
